import { Route } from '@angular/router';
import { RegisterFormComponent } from './register-form/register-form.component';
import { StepCustomerInfoComponent } from './step-customer-info/step-customer-info.component';
import { StepEstablishmentComponent } from './step-establishment/step-establishment.component';
import { StepAccountComponent } from './step-account/step-account.component';
import { StepSubscriptionComponent } from './step-subscription/step-subscription.component';
import { StepSuccessComponent } from './step-success/step-success.component';
import { StepEstablishmentGuard } from './step-establishment/step-establishment.guard';
import { StepAccountGuard } from './step-account/step-account.guard';
import { StepCustomerInfoGuard } from './step-customer-info/step-customer-info.guard';
import { StepSubscriptionGuard } from './step-subscription/step-subscription.guard';
import { StepSuccessGuard } from './step-success/step-success.guard';
import { RegisterFormGuard } from './register-form/register-form.guard';
import { ReactivateComponent } from './reactivate/reactivate.component';

export const subscriptionWizardRegistrationRoutes: Route[] = [
  {
    path: 'reactivacion/:subscriptionId',
    component: ReactivateComponent
  },
  {
    path: '',
    component: RegisterFormComponent,
    canActivate: [RegisterFormGuard],
    children: [
      {
        path: 'customer',
        component: StepCustomerInfoComponent,
        canActivate: [StepCustomerInfoGuard],
      },
      {
        path: 'establishment',
        component: StepEstablishmentComponent,
        canActivate: [StepEstablishmentGuard],
      },
      {
        path: 'account',
        component: StepAccountComponent,
        canActivate: [StepAccountGuard],
      },
      {
        path: 'payment',
        component: StepSubscriptionComponent,
        canActivate: [StepSubscriptionGuard],
      },
    ],
  },
  {
    path: 'success',
    component: StepSuccessComponent,
    canActivate: [StepSuccessGuard],
  },
];
